const TTL_MS = 2 * 60 * 1000;

/**
 * Controller note 9: `DecisionDrawer`'s own "a fix may still be finishing"
 * flag lives in local state, so it resets on every mount -- and the drawer
 * IS remounted fresh (key={row.id}, note 10) whenever it closes and the same
 * row is reopened. HowTab keeps one of these instead, so that flag survives
 * a close/reopen for two minutes. `now` is injectable so the TTL boundary is
 * tested without a real clock or fake timers.
 */
export class FixPendingStore {
  private readonly since = new Map<string, number>();

  constructor(private readonly now: () => number = () => Date.now()) {}

  set(taskId: string, pending: boolean): void {
    if (pending) this.since.set(taskId, this.now());
    else this.since.delete(taskId);
  }

  isPending(taskId: string): boolean {
    const at = this.since.get(taskId);
    if (at === undefined) return false;
    if (this.now() - at >= TTL_MS) {
      // Fix round 1 (Minor): prune on read so an expired entry doesn't sit in
      // the Map for the rest of the mount's life -- HowTab never calls `set`
      // again for a row nobody reopens.
      this.since.delete(taskId);
      return false;
    }
    return true;
  }
}
